import React from "react";
import { Subscription } from "../../../components/admin/Dashboard/billing/Subscription";
import FollowNewCom from "../../../components/admin/Dashboard/following/FollowNewCompanies";
import { useSelector } from "react-redux";
import { BillingWrapper } from "../../../components/admin/Dashboard/billing/BillingWrapper";
import BillingComponent from "../../../components/admin/Dashboard/billing/BillingHistory";


const Billing = () => {
  const { userInfo } = useSelector((state) => state.auth);


  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-10 gap-4 h-full">
        <div className="w-full col-start-1 col-end-8">
          <BillingWrapper />
          <Subscription />
        </div>
        <div className="w-full col-start-8 col-end-11 flex flex-col">
          <FollowNewCom type="payment" />
        </div>
      </div>
    </>
  );
};

export default Billing;
